import type { CommunitySpaceMember, CommunitySpaceMembersResponse } from '~/interfaces/community';

import { type MemberFeedPage, useMemberPagedFeed } from './useMemberPagedFeed';

const SPACE_MEMBERS_PATH = '/community/space_members';

const fetchSpaceMembersPage = async (
  spaceSlug: string,
  cursor: string | undefined,
): Promise<MemberFeedPage<CommunitySpaceMember>> => {
  const params = new URLSearchParams({ space_slug: spaceSlug });
  if (cursor) params.set('cursor', cursor);

  const response = await fetch(`${SPACE_MEMBERS_PATH}?${params}`);
  if (!response.ok) throw new Error('Failed to fetch space members');

  const data: CommunitySpaceMembersResponse = await response.json();
  return { items: data.members, meta: data.meta };
};

export const useSpaceMembers = (spaceSlug: string, enabled: boolean) => {
  const { items, pages, ...rest } = useMemberPagedFeed<CommunitySpaceMember>({
    queryKey: ['community-space-members', spaceSlug],
    fetchPage: (cursor) => fetchSpaceMembersPage(spaceSlug, cursor),
    enabled,
  });

  return { members: items, totalCount: pages?.[0]?.meta.total_count ?? 0, ...rest };
};
